import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { CustomHttp } from "../../../common/customHttp.service";
import { ApiUrl } from "../../../common/apiUrls";
import { MainAppComponent } from "../../../layout/layout.component";
import { MediaFileCategoryTypesEnum } from "../../../common/enumcontainer.enum";

@Component({
  selector: "addeditnabllogo",
  templateUrl: "./addeditnabllogo.component.html",
  styleUrls: ["./addeditnabllogo.component.scss"],
})
export class AddEditNablLogoComponent implements OnInit {
  logoForm: FormGroup;
  previewImage: string;
  mediaFileId: number = null;
  baseUrl: string;
  isSubmitted = false;
  isEdit: boolean = false;
  @ViewChild("fileInput") fileInput: ElementRef;

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _formBuilder: FormBuilder,
    private _http: CustomHttp,
    private _appUrl: ApiUrl,
    private _mApp: MainAppComponent,
    private _toastrService: ToastrService,
  ) {
    this.baseUrl = this._appUrl.baseUrl;
  }

  ngOnInit() {
    this._route.params.subscribe((params) => {
      this.mediaFileId = params["id"] ? +params["id"] : null;
      this.isEdit = !!this.mediaFileId;

      this.logoForm = this._formBuilder.group({
        MediaFileId: [null],
        Name: ["", Validators.required],
        FileName: [""],
        ImgBinary: ["", this.isEdit ? [] : [Validators.required]], 
      });

      if (this.isEdit) {
        this.LoadNablLogo();
      }
    });
  }

  LoadNablLogo() {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetMediaFileById + this.mediaFileId).subscribe(
      (data) => {
        this._mApp.HideLoader();
        const res = data.json();
        if (res && res.Result != null) {
          this.logoForm.patchValue({
            Name: res.Result.DisplayName,
            // CategoryId: res.Result.MediaFileCategoryTypeId,
          });
        }
      },
      (error) => {
        this._mApp.HideLoader();
        this._toastrService.error(
          (error && error.error && error.error.Result) || "Failed to load data",
        );
      },
    );
  }

  SetLogoValues(item: any) {
    this.logoForm.patchValue({
      MediaFileId: item.LogoId || null,
      Name: item.Name || "",
      FileName: item.FileName || "",
      ImgBinary: "",
    });

    this.previewImage = item.FilePath ? this.baseUrl + item.FilePath : null;
  }

  fileChange(evt: any) {
    const files = evt.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      const ext = file.name.split(".").pop().toLowerCase();
      if (["jpeg", "png", "jpg"].includes(ext)) {
        const reader = new FileReader();
        reader.onload = () => {
          const base64 = reader.result as string;
          this.previewImage = base64;
          this.logoForm.patchValue({
            FileName: file.name,
            ImgBinary: base64,
          });
        };
        reader.readAsDataURL(file);
      } else {
        if (this.fileInput) {
          this.fileInput.nativeElement.value = "";
        }
        this._toastrService.error(
          "Invalid file type. Please upload JPEG, PNG, or JPG images only.",
        );
      }
    }
  }

  OnSubmit() {
    this.isSubmitted = true;
    if (this.logoForm.invalid) {
      return;
    }

    const imgBinary = this.logoForm.value.ImgBinary;
    const existingPreview = this.previewImage;
    if (!imgBinary && !existingPreview && !this.isEdit) {
      this._toastrService.error("Please upload a NABL logo image", "");
      return;
    }

    const model = {
      MediaFileId: this.isEdit ? this.mediaFileId : null,
      MediaFileCategoryTypeId: MediaFileCategoryTypesEnum.NABL_Logo,
      DisplayName: this.logoForm.value.Name,
      FileName: this.logoForm.value.FileName || "",
      ImgBinary: imgBinary || "",
    };

    this._mApp.ShowLoader();
    this._http.post(this._appUrl.upsertSignature, model).subscribe(
      (data) => {
        this._mApp.HideLoader();
        this._toastrService.success(
          this.mediaFileId
            ? "Logo updated successfully"
            : "Logo added successfully",
          "",
        );
        this._router.navigate(["/nabllogos"]);
      },
      (error) => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result, "");
      },
    );
  }

  OnCancel() {
    this._router.navigate(["/nabllogos"]);
  }
}
